import { MapContainer, Marker, Popup, TileLayer, ZoomControl, LayersControl, LayerGroup, useMap } from 'react-leaflet';
import axios from '../axios';
import React, { useState, useEffect, useMemo, useContext } from 'react';
import 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css';
import Wkt from 'wicket';
import { myIconCPT, myIconCPTU, myIconCPTE, myIconDMT, myIconSDMT, myIconSONDAGGIO, myIconHVSR, myIconMASW, myIconDH, icon,myIconDelete } from '../custom_icon';
import LeafletRuler from "../LeafletRuler";
import MarkerClusterGroup from "react-leaflet-markercluster";
import "react-leaflet-markercluster/dist/styles.min.css";
import { OpenStreetMapProvider, GeoSearchControl } from 'leaflet-geosearch';
import "leaflet-geosearch/dist/geosearch.css";
import { useNavigate } from 'react-router-dom';
import './MapComponent.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { openCPTUReport } from '../components_software/report_CPTUE';
import { openMultiCPTUReport } from '../components_software/multireport_CPTUE';
import { openMultiCPTReport } from '../components_software/multireport_CPT';
import { openCPTReport } from '../components_software/report_CPT';
import { openSONDAGGIOReport } from '../components_software/report_SONDAGGIO';
import { openHVSRReport } from '../components_software/report_hvsr';
import { openMASWReport } from '../components_software/report_masw';



function LeafletgeoSearch() {
  const map = useMap();

  useEffect(() => {
    const provider = new OpenStreetMapProvider();
    const searchControl = new GeoSearchControl({ provider, marker: { icon } });
    map.addControl(searchControl);
    return () => map.removeControl(searchControl);
  }, [map]);

  return null;
}


const FilteredMarkers = ({ points, filters, icons, viewData, toelabData, handleDelete, navigate, toggleSelection, selectedItems}) => {
  const filteredPoints = useMemo(() => {
    return points.filter(point => filters.includes(point.tipo));
  }, [points, filters]);

  // Mappa i punti filtrati in marker
  return filteredPoints.map((point, i) => {
    // Se il punto è cancellato usa l'icona DELETE, altrimenti quella normale
    const icon = point.is_deleted ? icons.DELETE : icons[point.tipo];

    // Controlla se il punto è selezionato
    const isSelected = selectedItems.some(
      p => p.id === point.id && p.tipo === point.tipo
    );


    return (
      <Marker key={i} position={[point.coords[1], point.coords[0]]} icon={icon}>
          <Popup>
            <div className="popup-content">
              <div>ID: {point.id}</div>
              <div>Tipologia: {point.tipo}</div>
              {/* Bottoni in riga */}
              <div className="popup-actions">
                <button className="popup-btn" onClick={() => viewData(point.id, point.tipo)}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                    <path strokeLinecap="round" strokeLinejoin="round"d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                  </svg>
                </button>

                <button className="popup-btn" onClick={() => toelabData(point.id, point.tipo)}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                     <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                  </svg>
                </button>

                <button className="popup-btn" onClick={() => handleDelete(point.id, point.tipo_prova)}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                     <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </button>

              </div>
             {/* Checkbox con stile bottone */}
             {point.tipo !== "SONDAGGIO" && (
                  <button
                    className="popup-btn"
                    onClick={() => toggleSelection(point.id, point.tipo)}
                    style={{ width: 'auto', padding: '0 8px', gap: '4px' }}
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => {}}
                      onClick={(e) => e.stopPropagation()}
                      style={{ margin: 0, width: '14px', height: '14px' }}
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      strokeWidth={1.5} stroke="currentColor" className="icon">
                      <path strokeLinecap="round" strokeLinejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                  </button>
             )}
            </div>
          </Popup>
      </Marker>
          );
        }); // <-- this closes map
      }; // <-- this closes FilteredMarkers


const buttonStyle = {
  fontFamily: 'roboto',
  fontSize: '11px',
  border: '2px solid #12455b',
  color: 'black',
  padding: '5px 16px',
  cursor: 'pointer',
  borderRadius: '12px',
  backgroundColor: 'white',
  marginTop: '3px'
};

export const MapComponent = ({ positionDefault = [44.36, 11.34], filters }) => {


  const [geopoints, setGeopoints] = useState([]);
  const [sispoints, setSispoints] = useState([]);
  const [pageData, setPageData] = useState({ pagesis: 0, pagegeo: 0 });
  const [loading, setLoading] = useState({ loadingGeo: false, loadingSIS: false });
  //costruzione report e multireport
  const [selectedItems, setSelectedItems] = useState([]); //serve per la lista degli oggetti per multireport

  const navigate = useNavigate();

  //selezione multireport
  const [activeType, setActiveType] = useState(null);



  //delete prove geognostiche
  const handleDelete = async (id, tipo, hardDelete = false) => {
      const buttonStyle = {
        padding: '6px 12px',
        marginRight: '8px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '12px'
      };

      const okStyle = {
        ...buttonStyle,
        backgroundColor: '#4CAF50',
        color: 'white'
      };

      const cancelStyle = {
        ...buttonStyle,
        backgroundColor: '#f44336',
        color: 'white'
      };

      // Primo toast
      const firstConfirm = await new Promise((resolve) => {
        toast.info(
          <div>
            Stai per eliminare la prova. Continuare?
            <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'flex-end' }}>
              <button style={okStyle} onClick={() => { toast.dismiss(); resolve(true); }}>OK</button>
              <button style={cancelStyle} onClick={() => { toast.dismiss(); resolve(false); }}>Annulla</button>
            </div>
          </div>,
          { autoClose: false, closeButton: false }
        );
      });
      if (!firstConfirm) return;

      // Secondo toast
      const secondConfirm = await new Promise((resolve) => {
        toast.warning(
          <div>
            Stai eliminando la prova ID {id}. La procedura è irreversibile. Continuare?
            <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'flex-end' }}>
              <button style={okStyle} onClick={() => { toast.dismiss(); resolve(true); }}>OK</button>
              <button style={cancelStyle} onClick={() => { toast.dismiss(); resolve(false); }}>Annulla</button>
            </div>
          </div>,
          { autoClose: false, closeButton: false }
        );
      });
      if (!secondConfirm) return;

      // Esegui la cancellazione
      try {
        const url = tipo === "SIS"
          ? `https://www.hat.sofhare.com/datasis/proves/${id}/`
          : `https://www.hat.sofhare.com/datacpt/proves/${id}/`;

        await axios.patch(
          url,
          { is_deleted: true, hard_delete: hardDelete },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );

        if (!hardDelete) {
          if (tipo === "SIS") {
            setSispoints(prev => prev.map(p => p.id === id ? { ...p, is_deleted: true } : p));
          } else {
            setGeopoints(prev => prev.map(p => p.id === id ? { ...p, is_deleted: true } : p));
          }
        } else {
          if (tipo === "SIS") {
            setSispoints(prev => prev.filter(p => p.id !== id));
          } else {
            setGeopoints(prev => prev.filter(p => p.id !== id));
          }
        }

        toast.success(`Prova ID ${id} eliminata con successo!`, { autoClose: 2000 });
      } catch (error) {
        console.error("Errore nella cancellazione:", error.response ? error.response.data : error.message);
        toast.error("Si è verificato un errore durante l'eliminazione della prova.", { autoClose: 3000 });
      }
    };


  useEffect(() => {
    countDATA();
  }, []);

  useEffect(() => {
    if (pageData.pagegeo > 0) {
      renderData('geo');
    }
  }, [pageData.pagegeo]);

  useEffect(() => {
    if (pageData.pagesis > 0) {
      renderData('sis');
    }
  }, [pageData.pagesis]);


  // selezione geometria multireport
  const toggleSelection = (id, tipo) => {
      setSelectedItems(prev => {
        const exists = prev.find(p => p.id === id);

        // 🔴 SE ESISTE → RIMOZIONE
        if (exists) {
          const newItems = prev.filter(p => p.id !== id);

          if (newItems.length === 0) {
            setActiveType(null);
          }

          return newItems;
        }

        // 🔥 SE NON ESISTE TIPO ATTIVO → LO SETTO
        if (!activeType) {
          setActiveType(tipo);
          return [...prev, { id, tipo }];
        }

        // 🚨 BLOCCO TIPO DIVERSO
        if (tipo !== activeType) {
          toast.error(`Hai selezionato ${activeType}, per cambiare tipologia Multireport annulla selezione`);
          return prev; // ❌ NON aggiunge nulla
        }

        // ✅ OK AGGIUNTA
        return [...prev, { id, tipo }];
      });
    };

  const groupedByType = selectedItems.reduce((acc, item) => {
      const tipo = item.tipo || 'UNKNOWN';
      if (!acc[tipo]) acc[tipo] = [];
      acc[tipo].push(item.id);
      return acc;
    }, {});

  const countDATA = async () => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    try {
      const response = await axios.get('https://www.hat.sofhare.com/counter/proves/');
      const page = Math.ceil(response.data.find(item => item.type === 'TOTSIS').Tot_geog / 20);
      const pageg = Math.ceil(response.data.find(item => item.type === 'TOTCPT').Tot_geog / 20);
      setPageData({ pagesis: page, pagegeo: pageg });
    } catch (error) {
      console.error('Error fetching page data:', error);
    }
  };

  const renderData = async (type) => {
    setLoading(prevLoading => ({ ...prevLoading, [`loading${type === 'geo' ? 'Geo' : 'SIS'}`]: true }));
    const totalPages = type === 'geo' ? pageData.pagegeo : pageData.pagesis;
    const url = type === 'geo' ? 'https://www.hat.sofhare.com/datacpt/proves/' : 'https://www.hat.sofhare.com/datasis/proves/';
    const setData = type === 'geo' ? setGeopoints : setSispoints;

    try {
      for (let page = 1; page <= totalPages; page++) {
        const response = await axios.get(`${url}?page=${page}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        const newData = response.data.results.map(item => {
          const wkt_geom = item.geom.replace('SRID=4326;', '');
          const wkt = new Wkt.Wkt();
          wkt.read(wkt_geom);
          const geojson_geom = wkt.toJson();
          const coords2 = geojson_geom['coordinates'];
          return { coords: coords2, id: item.id, tipo: item.tipo_prova,is_deleted: item.is_deleted };
        });
        setData(prevPoints => [...prevPoints, ...newData]);
      }
    } catch (error) {
      console.error(`Error fetching ${type.toUpperCase()} data:`, error.response ? error.response.data : error.message || error);
    } finally {
      setLoading(prevLoading => ({ ...prevLoading, [`loading${type === 'geo' ? 'Geo' : 'SIS'}`]: false }));
    }
  };

  const viewData = (id, tipo) => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
        let urlData;
        if (tipo === 'CPT' || tipo === 'CPTE' || tipo === 'CPTU'|| tipo === 'DMT' || tipo === 'SDMT' || tipo === 'SONDAGGIO') {
            urlData = `https://www.hat.sofhare.com/outcpt/${id}/proves/`;
        } else {
            urlData = `https://www.hat.sofhare.com/outsis/${id}/proves/`;
        }
        axios.get(urlData)
            .then(res => {
                const responseData = res.data[0];
                const wkt_geom = responseData.geom.replace('SRID=4326;', '');
                const wkt = new Wkt.Wkt();
                wkt.read(wkt_geom);
                const geojson_geom = wkt.toJson();
                const coords = geojson_geom['coordinates'];
                const coords2 = [coords[1], coords[0]];

                if (tipo === 'CPTE' || tipo === 'CPTU') {
                    const veryjson = responseData.output_data.replace(/'/g, '"');
                    const datjson = JSON.parse(veryjson);
                    const parQC = datjson[0].QC;
                    const prof = datjson[0].H;
                    const parfs = datjson[0].FS;
                    const paru = datjson[0].UU; //pressione intersitziale misurata
                    const paru0 = datjson[0].U0; //pressione acqua stimata
                    const parrf = datjson[0].Rf;
                    const park = datjson[0].K; //permeabilità
                    const parocr = datjson[0].OCR;
                    const pardr = datjson[0].DR;
                    const pares = datjson[0].Es; //modulo di young
                    const parg0 = datjson[0].G0; //modulo di taglio
                    const parko = datjson[0].k0; //modulo di taglio g0
                    const parcu = datjson[0].cu;
                    const parcurem = datjson[0].cuRem; //modulo di taglio g0
                    const parm = datjson[0].M; //modulo di taglio
                    const parphi = datjson[0].phi; //modulo di taglio g0
                    const parphip = datjson[0].phip; //modulo di taglio g0
                    //grafici SBT
                    const parQt = datjson[0].Qt;
                    const parQtn = datjson[0].Qtn;
                    //ic o icn
                    const paricn = datjson[0].IC; //ic oer SBT normalizzato nel plot stratigrafico
                    const paric = datjson[0].IC_SBT //ic oer SBT 1990 normale e 1986 nel plot stratigrafico
                    //ChoseLito è l'array con la litologia in base l'autore scelto
                    const parLT= datjson[0].Lito
                    const parautLT= datjson[0].choseLito // è l'autore scelto per la litologia. 0 robertson normalizzato, 1 robertson, 2 robertson campanella 1986
                    //dati intestazione
                    const name = responseData.nome_prova
                    const comm = responseData.committente
                    const loc = responseData.luogo
                    const add = responseData.indirizzo
                    const fad = datjson[0].falda
                    //elaborazione stratigrafia
                    const { unitup, unitdw, mlito, mtype, mname, mgam, mcu, mphi, mdr, mm} = (() => {
                        if (responseData.stratigraphy_data) {
                            try {
                                const veryjson2 = responseData.stratigraphy_data.replace(/'/g, '"');
                                const datjson2 = JSON.parse(veryjson2);
                                const first = datjson2[0] || {}; // sicurezza se array vuoto
                                return {
                                    unitup: first.Tetto ?? [],
                                    unitdw: first.Letto ?? [],
                                    mlito: first.Mlito ?? [],
                                    mtype: first.Tipoterr ?? '',       // singolo valore stringa
                                    mname: first.nomeS ?? '',       // singolo valore stringa
                                    mgam: first.MGamma ?? [],
                                    mcu: first.MCu ?? [],
                                    mphi: first.MPhi ?? [],
                                    mdr: first.MDr ?? [],
                                    mm: first.MM ?? []
                                };
                            } catch (e) {
                                console.error("JSON non valido:", e);
                            }
                        }
                        // se stringa vuota/nulla o errore JSON
                        return {
                            unitup: [],
                            unitdw: [],
                            mlito: [],
                            mtype: '',
                            mname: '',
                            mgam: [],
                            mcu: [],
                            mphi: [],
                            mdr: [],
                            mm: []
                        };
                    })();
                    openCPTUReport({name,tipo,comm,loc,add,fad,parQC, prof, parfs,paru,paru0,parrf,park,parocr,pardr,pares,parg0,
                        parko, parcu, parcurem, parm, parphi,  parphip, parQt, parQtn, paricn, paric, parLT, parautLT, unitup,
                         unitdw, mlito, mtype, mname, mgam, mcu, mphi, mdr, mm});

                }else if (tipo === 'CPT') {
                    const veryjson = responseData.output_data.replace(/'/g, '"');
                    const datjson = JSON.parse(veryjson);
                    const parQC = datjson[0].QC;
                    const prof = datjson[0].H;
                    const parfs = datjson[0].FS;
                    const parrf = datjson[0].Rf;
                    const park = datjson[0].K; //permeabilità
                    const parocr = datjson[0].OCR;
                    const pares = datjson[0].Ey; //modulo di young
                    const paded = datjson[0].Eu; //modulo di deformazione non drenato
                    const parm = datjson[0].M; //modulo di taglio
                    const pardr = datjson[0].DR;
                    const parg0 = datjson[0].G0; //modulo di taglio
                    const parcu = datjson[0].cu;
                    const parphip = datjson[0].phip; //modulo amgolo attrito primo
                    //ChoseLito è l'array con la litologia in base l'autore scelto
                    const parautLT= datjson[0].choseLito // è l'autore scelto per la litologia. 0 shmertmann, 1 beghemann
                    const ltMap = {0:0,1:10,2:11,3:9,4:7,5:6,6:5,7:4,8:3,9:8,10:2,11:1};
                    const parLTdarimap= datjson[0].Lito
                    const parLT = (parautLT === 0)
                        ? parLTdarimap.map(v => ltMap[v] ?? 0)
                        : parLTdarimap; //devo rimappare i valori perche avevo fatto così e ormai sono archiviati i datic osì

                    //dati intestazione
                    const name = responseData.nome_prova
                    const comm = responseData.committente
                    const loc = responseData.luogo
                    const add = responseData.indirizzo
                    const fad = datjson[0].falda
                    //elaborazione stratigrafia
                    const { unitup, unitdw, mlito,mlitoval, mtype, mname, mgam, mgams, mcu, mphi, mdr, mm} = (() => {
                        if (responseData.stratigraphy_data) {
                            try {
                                const veryjson2 = responseData.stratigraphy_data.replace(/'/g, '"');
                                const datjson2 = JSON.parse(veryjson2);
                                const first = datjson2[0] || {}; // sicurezza se array vuoto

                                // Prendi mlito originale
                                const mlito = first.Mlito ?? [];

                                // Applica la mappa a mlito
                                const mappedMlito = (parautLT === 0)
                                    ? mlito.map(v => ltMap[v] ?? 0)
                                    : mlito;

                                return {
                                    unitup: first.Tetto ?? [],
                                    unitdw: first.Letto ?? [],
                                    mlito: mappedMlito,  // ✅ Usa quello mappato
                                    mlitoval: mlito,
                                    mtype: first.Tipoterr ?? '',       // singolo valore stringa
                                    mname: first.nomeS ?? '',       // singolo valore stringa
                                    mgam: first.MGamma ?? [],
                                    mgams: first.MGammaS ?? [],
                                    mcu: first.MCu ?? [],
                                    mphi: first.MPhi ?? [],
                                    mdr: first.MDr ?? [],
                                    mm: first.MM ?? []
                                };
                            } catch (e) {
                                console.error("JSON non valido:", e);
                            }
                        }
                        // se stringa vuota/nulla o errore JSON
                        return {
                            unitup: [],
                            unitdw: [],
                            mlito: [],
                            mtype: '',
                            mname: '',
                            mgam: [],
                            mgams: [],
                            mcu: [],
                            mphi: [],
                            mdr: [],
                            mm: []
                        };
                    })();
                    openCPTReport({name,tipo,comm,loc,add,fad,parQC,prof,parfs,parrf,park,parocr,pardr,pares,paded,parg0,
                        parcu,parm,parphip,parLT,parLTdarimap,parautLT,unitup,unitdw,mlito,mlitoval,mtype,mname,mgam,mgams,mcu,mphi,mdr,mm});

                }else if (tipo === 'DMT' || tipo === 'SDMT') {
                    console.log('in sviluppo')
                }else if (tipo === 'SONDAGGIO') {
                    let datjson;
                    try {

                        // =========================
                        // NORMALIZZAZIONE JSON
                        // =========================
                        let raw = responseData.output_data;

                        // Se arriva già oggetto JSON
                        if (typeof raw !== "string") {
                            datjson = raw;
                        } else {

                            // Conversione Python -> JSON
                            const normalized = raw
                                .replace(/\bNone\b/g, "null")
                                .replace(/\bTrue\b/g, "true")
                                .replace(/\bFalse\b/g, "false")
                                .replace(/'/g, '"');

                            console.log("NORMALIZED JSON:", normalized);

                            datjson = JSON.parse(normalized);
                        }

                        // =========================
                        // DATI PRINCIPALI
                        // =========================
                        const d0 = datjson?.[0];

                        if (!d0) {
                            throw new Error("SONDAGGIO vuoto");
                        }

                        // =========================
                        // 🧾 ANAGRAFICA
                        // =========================
                        const nomeProva = d0.anagrafica?.nomeProva ?? "";
                        const committente = d0.anagrafica?.committente ?? "";
                        const localita = d0.anagrafica?.localita ?? "";
                        const indirizzo = d0.anagrafica?.indirizzo ?? "";
                        const dittes = d0.anagrafica?.dittes ?? "";
                        const op = d0.anagrafica?.op ?? "";

                        // =========================
                        // 📌 PARAMETRI
                        // =========================
                        const tipoProva = d0.Tipo ?? "";

                        const sonda = d0.parametri?.snd ?? "";
                        const tipologia = d0.parametri?.tp ?? "";
                        const carotiere = d0.parametri?.car ?? "";
                        const rivestimento = d0.parametri?.riv ?? "";
                        const profMax = d0.parametri?.profMax ?? 0;
                        const falda = d0.parametri?.falda ?? "";
                        const qpc = d0.parametri?.qpc ?? 0;
                        const qbf = d0.parametri?.qbf ?? "";
                        const qpz = d0.parametri?.qpz ?? "";
                        const note = d0.parametri?.note ?? "";

                        // =========================
                        // 📍 GEO
                        // =========================
                        const coordinate = d0.geom ?? "";

                        // =========================
                        // 🧱 STRATIGRAFIA
                        // =========================
                        const layers = Array.isArray(d0.layers) ? d0.layers : [];

                        const mH = layers.map(l => l.spessore ?? 0);
                        const mColor = layers.map(l => l.colore ?? "#cccccc");
                        const mTexture = layers.map(l => l.texture ?? "");
                        const mDesc = layers.map(l => l.descrizione ?? "");

                        // =========================
                        // 🧪 TESTS
                        // =========================
                        const tests = d0.tests ?? {};

                        const sptTests = tests.spt ?? [];
                        const pocketTests = tests.pkt ?? [];
                        const torvaneTests = tests.torvane ?? [];
                        const campioni = tests.campioni ?? [];
                        const fessurazioni = tests.fessurazioni ?? [];
                    // =========================
                    // 🚀 CHIAMATA FINALE (COME CPT)
                    // =========================
                    openSONDAGGIOReport({nomeProva,tipo,committente,localita,indirizzo,dittes,op,sonda,tipologia,carotiere,rivestimento,profMax,falda,qpc,qbf,qpz,note,coordinate,
                        mH,mColor,mTexture,mDesc,sptTests,pocketTests,torvaneTests,campioni,fessurazioni
                    });
                        } catch (err) {
                            console.error("Errore parsing SONDAGGIO:", err);
                            console.error("RAW DATA:", responseData.output_data);
                        }


                }else if (tipo === 'HVSR') {
                    const veryjson = responseData.data.replace(/'/g, '"');
                    const datjson = JSON.parse(veryjson);
                    const parMV = datjson['value'][0]['ModelV'];
                    const parMH = datjson['value'][0]['ModelH'];
                    const parcHVf = datjson['value'][0]['CurvaHVf']; // curva HV valori x
                    const parcHV = datjson['value'][0]['CurvaHV']; // curva HV valori y
                    const parcSF = datjson['value'][0]['Syntheticf']; // curva sintetica valori x
                    const parcS = datjson['value'][0]['Synthetic']; // curva sintetica valori y
                    const parstdDV = datjson['value'][0]['STDdev']; //deviazione standard della curva
                    const parpsub = datjson['value'][0]['Psub']; //profondità substrato archiviato che deterina la vs eq
                    const parVS = responseData.vsh; //valore Vs eq archiviato
                    //dati intestazione
                    const name = responseData.nome_prova
                    const comm = responseData.committente
                    const loc = responseData.luogo
                    const add = responseData.indirizzo

                    openHVSRReport({name,tipo,comm,loc,add,parMV,parMH,parcHVf,parcHV,parcSF,parcS,parstdDV,parpsub,parVS});

                    // Update the DataContext instead of navigating
                }else if (tipo === 'MASW') {
                    const veryjson = responseData.data.replace(/'/g, '"');
                    const datjson = JSON.parse(veryjson);
                    const parMV = datjson['value'][0]['ModelV'];
                    const parMH = datjson['value'][0]['ModelH'];
                    const parFP = datjson['value'][0]['freqPick'];
                    const parVFAS = datjson['value'][0]['Slowness'];
                    const parTRACE = datjson['value'][0]['traccia'];
                    const parpsub = datjson['value'][0]['Psub']; //profondità substrato archiviato che deterina la vs eq
                    const parVS = responseData.vsh; //valore Vs eq archiviato
                    const parinterval = datjson['value'][0]['Spacing'];; //valore Vs eq archiviato
                    //dati intestazione
                    const name = responseData.nome_prova
                    const comm = responseData.committente
                    const loc = responseData.luogo
                    const add = responseData.indirizzo
                    //immagine spettro masw
                    const parspettro = responseData.spettro;

                    openMASWReport({name,tipo,comm,loc,add,parMV,parMH,parFP,parVFAS,parTRACE,parpsub,parVS,parinterval,parspettro});

                }else {
                //in sviluppo
                }

            })
            .catch(errors => {
                console.error(errors);
            });
    };

  // build multireport
   const fetchProva = async (id, tipoProva) => {
      let urlData;

      if (['CPT','CPTE','CPTU','DMT','SDMT','SONDAGGIO'].includes(tipoProva)) {
        urlData = `https://www.hat.sofhare.com/outcpt/${id}/proves/`;
      } else if (['HVSR','MASW','DH'].includes(tipoProva)) {
        urlData = `https://www.hat.sofhare.com/outsis/${id}/proves/`;
      }

      console.log(urlData);

      const res = await axios.get(urlData);
      const data = res.data[0];

      // aggiungi tipo qui
      return { ...data, tipo: tipoProva };
    };


   const handleMultiReport = async () => {
      axios.defaults.headers.common['Authorization'] =
        `Bearer ${localStorage.getItem('token')}`;

      if (!activeType) {
        console.warn("Nessun tipo selezionato");
        return;
      }

      const ids = groupedByType[activeType] || [];

      if (ids.length === 0) {
        console.warn("Nessun elemento per il tipo:", activeType);
        return;
      }

      try {
        const dataArray = await Promise.all(
          ids.map(id => {
            return fetchProva(id, activeType);
          })
        );

        const multiData = dataArray
          .map(responseData => {
            try {
              const tipo = responseData.tipo;

              if (tipo === 'CPTU' || tipo === 'CPTE') {
                const datjson = JSON.parse(
                  responseData.output_data.replace(/'/g, '"')
                );

                return {
                  name: responseData.nome_prova,
                  tipo,
                  parQC: datjson[0].QC,
                  prof: datjson[0].H,
                  parfs: datjson[0].FS,
                  paru: datjson[0].UU,
                  parrf: datjson[0].Rf,
                  park: datjson[0].K,
                  parocr: datjson[0].OCR,
                  pardr: datjson[0].DR,
                  pares: datjson[0].Es,
                  parg0: datjson[0].G0,
                  parko: datjson[0].k0,
                  parcu: datjson[0].cu,
                  parm: datjson[0].M,
                  parphi: datjson[0].phi,
                  parphip: datjson[0].phip,
                  paricn: datjson[0].IC,
                  paric: datjson[0].IC_SBT,
                  parBq: datjson[0].Bq,
                  parQt: datjson[0].Qt,
                  parQtn: datjson[0].Qtn,
                  fad: datjson[0].falda,
                  parautLT: datjson[0].choseLito
                };

              } else if (tipo === 'CPT') {
                const datjson = JSON.parse(
                  responseData.output_data.replace(/'/g, '"')
                );

                return {
                  name: responseData.nome_prova,
                  tipo,
                  parQC: datjson[0].QC,
                  prof: datjson[0].H,
                  parfs: datjson[0].FS,
                  parrf: datjson[0].Rf,
                  park: datjson[0].K,
                  pardr: datjson[0].DR,
                  parcu: datjson[0].cu,
                  parphip: datjson[0].phip,
                  parm: datjson[0].M,
                  pares: datjson[0].Ey,
                  paded: datjson[0].Eu,
                  parg0: datjson[0].G0,
                  fad: datjson[0].falda,
                  parautLT: datjson[0].choseLito
                };

              } else if (tipo === 'MASW' || tipo === 'HVSR') {
                const datjson = JSON.parse(
                  responseData.data.replace(/'/g, '"')
                );

                return {
                  name: responseData.nome_prova,
                  tipo,
                  parMV: datjson.value[0].ModelV,
                  parMH: datjson.value[0].ModelH,
                  parcHVf: datjson.value[0].CurvaHVf,
                  parcHV: datjson.value[0].CurvaHV,
                  parcSF: datjson.value[0].Syntheticf,
                  parcS: datjson.value[0].Synthetic,
                  parstdDV: datjson.value[0].STDdev,
                  parpsub: datjson.value[0].Psub,
                  parVS: responseData.vsh
                };

              } else {
                console.warn("Tipo non gestito:", tipo);
                return null;
              }

            } catch (e) {
              console.error("Errore parsing JSON multiData", e);
              return null;
            }
          })
          .filter(Boolean);

        console.log("MULTI DATA:", multiData);

        // 🔥 UN SOLO REPORT (senza loop)
        if (activeType === 'CPTU' || activeType === 'CPTE') {
          openMultiCPTUReport(multiData);
        }

        if (activeType === 'CPT') {
          openMultiCPTReport(multiData);
        }

        if (activeType === 'MASW' || activeType === 'HVSR') {
          //openMultiMASWReport?.(multiData);
          console.log('dafare')
        }

      } catch (err) {
        console.error("Errore handleMultiReport", err);
      }
    };


  //invia dati all'elaboratore
  const toelabData = (id, tipo) => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
        let urlData;
        if (tipo === 'CPT' || tipo === 'CPTE' || tipo === 'CPTU'|| tipo === 'DMT' || tipo === 'SDMT' || tipo === 'SONDAGGIO') {
            urlData = `https://www.hat.sofhare.com/outcpt/${id}/proves/`;
        } else {
            urlData = `https://www.hat.sofhare.com/outsis/${id}/proves/`;
        }
        axios.get(urlData)
            .then(res => {
                const responseData = res.data[0];
                const wkt_geom = responseData.geom.replace('SRID=4326;', '');
                const wkt = new Wkt.Wkt();
                wkt.read(wkt_geom);
                const geojson_geom = wkt.toJson();
                const coords = geojson_geom['coordinates'];
                const coords2 = [coords[1], coords[0]];

                if (tipo === 'CPTE' || tipo === 'CPTU') {
                    const veryjson = responseData.output_data.replace(/'/g, '"');
                    const datjson = JSON.parse(veryjson);
                    const parQC = datjson[0].QC;
                    const prof = datjson[0].H;
                    const parfs = datjson[0].FS;
                    const paru = datjson[0].UU; //pressione intersitziale misurata
                    const parautLT= datjson[0].choseLito // è l'autore scelto per la litologia. 0 robertson normalizzato, 1 robertson, 2 robertson campanella 1986
                    let ulitologiaStr;
                    if (parautLT === 0) {
                        ulitologiaStr = "SBTn";  // Robertson normalizzato
                    } else if (parautLT === 1) {
                        ulitologiaStr = "SBT";   // Robertson
                    }

                    //dati intestazione
                    const name = responseData.nome_prova
                    const comm = responseData.committente
                    const loc = responseData.luogo
                    const add = responseData.indirizzo
                    const fad = datjson[0].falda
                    //TEAM
                    const team_id = responseData.team_id || "";
                    //variabili autori paramtrizzioni
                    const rawParamData = responseData.param_data;
                    // Step 1: Assicuriamoci che sia un oggetto JSON valido
                    let paramData;
                    try {
                        // Se è una stringa con apici singoli, convertiamo in JSON valido
                        const jsonStr = typeof rawParamData === "string"
                            ? rawParamData.replace(/'/g, '"')
                            : JSON.stringify(rawParamData);

                        paramData = JSON.parse(jsonStr);
                    } catch (error) {
                        console.error("Errore nel parsing di param_data:", error);
                        paramData = {};
                    }
                    // Step 2: Se il JSON è vuoto {}, consideriamo tutti i parametri 0
                    const waut = paramData?.waut ?? "SBTg";
                    const phiaut = paramData?.phiaut ?? "km90";
                    const fpt = paramData?.fpt ?? 16;
                    const geompt = paramData?.geompt ?? "Tp";

                    //elaborazione stratigrafia
                    const { unitup, unitdw, mlito, mtype, mname, mgam, mcu, mphi, mdr, mm} = (() => {
                        if (responseData.stratigraphy_data) {
                            try {
                                const veryjson2 = responseData.stratigraphy_data.replace(/'/g, '"');
                                const datjson2 = JSON.parse(veryjson2);
                                const first = datjson2[0] || {}; // sicurezza se array vuoto
                                return {
                                    unitup: first.Tetto ?? [],
                                    unitdw: first.Letto ?? [],
                                    mlito: first.Mlito ?? [],
                                    mtype: first.Tipoterr ?? '',       // singolo valore stringa
                                    mname: first.nomeS ?? '',       // singolo valore stringa
                                    mgam: first.MGamma ?? [],
                                    mcu: first.MCu ?? [],
                                    mphi: first.MPhi ?? [],
                                    mdr: first.MDr ?? [],
                                    mm: first.MM ?? []
                                };
                            } catch (e) {
                                console.error("JSON non valido:", e);
                            }
                        }
                        // se stringa vuota/nulla o errore JSON
                        return {
                            unitup: [],
                            unitdw: [],
                            mlito: [],
                            mtype: '',
                            mname: '',
                            mgam: [],
                            mcu: [],
                            mphi: [],
                            mdr: [],
                            mm: []
                        };
                    })();
                    navigate('/ves_cpt', {state: {id,coords2,name,tipo,comm,loc,add,fad,parQC,prof,parfs,paru,parautLT,ulitologiaStr,waut,phiaut,
                     fpt,geompt,unitup,unitdw,mlito,mtype,mname,mgam,mcu,mphi,mdr,mm,team_id}});

                }else if (tipo === 'CPT') {
                    const veryjson = responseData.output_data.replace(/'/g, '"');
                    const datjson = JSON.parse(veryjson);
                    const parQC = datjson[0].QC;
                    const prof = datjson[0].H;
                    const parfs = datjson[0].FS;
                    const parautLT= datjson[0].choseLito // è l'autore scelto per la litologia. 0 shmertmann, 1 beghemann
                    let ulitologiaStr;
                    if (parautLT === 0) {
                        ulitologiaStr = "s78";  // Robertson normalizzato
                    } else if (parautLT === 1) {
                        ulitologiaStr = "bg65";   // Robertson
                    }

                    const ltMap = {0:0,1:10,2:11,3:9,4:7,5:6,6:5,7:4,8:3,9:8,10:2,11:1};
                    const parLTdarimap= datjson[0].Lito
                    const parLT = (parautLT === 0)
                        ? parLTdarimap.map(v => ltMap[v] ?? 0)
                        : parLTdarimap; //devo rimappare i valori perche avevo fatto così e ormai sono archiviati i datic osì

                    //dati intestazione
                    const name = responseData.nome_prova
                    const comm = responseData.committente
                    const loc = responseData.luogo
                    const add = responseData.indirizzo
                    const fad = datjson[0].falda
                    //TEAM
                    const team_id = responseData.team_id || "";
                    //variabili autori paramtrizzioni
                    const rawParamData = responseData.param_data;
                    // Step 1: Assicuriamoci che sia un oggetto JSON valido
                    let paramData;
                    try {
                        // Se è una stringa con apici singoli, convertiamo in JSON valido
                        const jsonStr = typeof rawParamData === "string"
                            ? rawParamData.replace(/'/g, '"')
                            : JSON.stringify(rawParamData);

                        paramData = JSON.parse(jsonStr);
                    } catch (error) {
                        console.error("Errore nel parsing di param_data:", error);
                        paramData = {};
                    }
                    // Step 2: Se il JSON è vuoto {}, consideriamo tutti i parametri 0
                    const wautP = paramData?.wautP ?? "ro10";
                    const phiautP = paramData?.phiautP ?? "beer";
                    const moautP = paramData?.moautP ?? "mg75";
                    const yoautP = paramData?.yoautP ?? "s78";
                    const drautP = paramData?.drautP ?? "la83";
                    const cuautP = paramData?.cuautP ?? "mk88";
                    const ocrautP = paramData?.ocrautP ?? "m91";
                    const mdfautP = paramData?.mdfautP ?? "v";
                    const mdfautPc = paramData?.mdfautPc ?? "mg75";

                    //elaborazione stratigrafia
                    const { unitup, unitdw, mlito,mlitoval, mtype, mname, mgam, mgams, mcu, mphi, mdr, mm} = (() => {
                        if (responseData.stratigraphy_data) {
                            try {
                                const veryjson2 = responseData.stratigraphy_data.replace(/'/g, '"');
                                const datjson2 = JSON.parse(veryjson2);
                                const first = datjson2[0] || {}; // sicurezza se array vuoto
                                // Prendi mlito originale
                                const mlito = first.Mlito ?? [];
                                // Applica la mappa a mlito
                                const mappedMlito = (parautLT === 0)
                                    ? mlito.map(v => ltMap[v] ?? 0)
                                    : mlito;

                                return {
                                    unitup: first.Tetto ?? [],
                                    unitdw: first.Letto ?? [],
                                    mlito: mappedMlito,  // ✅ Usa quello mappato
                                    mlitoval: mlito,
                                    mtype: first.Tipoterr ?? '',       // singolo valore stringa
                                    mname: first.nomeS ?? '',       // singolo valore stringa
                                    mgam: first.MGamma ?? [],
                                    mgams: first.MGammaS ?? [],
                                    mcu: first.MCu ?? [],
                                    mphi: first.MPhi ?? [],
                                    mdr: first.MDr ?? [],
                                    mm: first.MM ?? []
                                };
                            } catch (e) {
                                console.error("JSON non valido:", e);
                            }
                        }
                        // se stringa vuota/nulla o errore JSON
                        return {
                            unitup: [],
                            unitdw: [],
                            mlito: [],
                            mlitoval: [],
                            mtype: '',
                            mname: '',
                            mgam: [],
                            mgams: [],
                            mcu: [],
                            mphi: [],
                            mdr: [],
                            mm: []
                        };
                    })();

                    navigate('/ves_cpt', {state: {id,coords2,name,tipo,comm,loc,add,fad,parQC,prof,parfs,parautLT,parLTdarimap,ulitologiaStr,wautP,phiautP,moautP,yoautP,drautP,
                        cuautP,ocrautP,mdfautP,mdfautPc,unitup,unitdw,mlito,mlitoval,mtype,mname,mgam,mgams,mcu,mphi,mdr,mm,team_id}});


                }else if (tipo === 'DMT' || tipo === 'SDMT') {
                    console.log('in sviluppo')
                }else if (tipo === 'SONDAGGIO') {
                    const raw =
                        responseData.output_data ??
                        responseData.input_data;
                    let datjson;
                    try {
                        // =========================
                        // CASO OGGETTO GIÀ PARSATO
                        // =========================
                        if (typeof raw !== "string") {
                            datjson = raw;
                        } else {

                            // =========================
                            // NORMALIZZAZIONE SICURA
                            // =========================
                            let cleaned = raw
                                .trim()
                                // None / True / False Python → JSON
                                .replace(/\bNone\b/g, "null")
                                .replace(/\bTrue\b/g, "true")
                                .replace(/\bFalse\b/g, "false");

                            // =========================
                            // PROVA JSON STANDARD
                            // =========================
                            try {
                                datjson = JSON.parse(cleaned);
                            } catch (err) {

                                console.warn("⚠️ JSON parse fallito, tentativo fallback");

                                // =========================
                                // FALLBACK (SAFE eval NON consigliato ma controllato)
                                // =========================
                                datjson = new Function("return " + cleaned)();
                            }
                        }

                    } catch (err) {
                        console.error("❌ Errore parsing SONDAGGIO:", err);
                        console.error("RAW DATA:", raw);
                        return;
                    }

                    const sondaggio = datjson?.[0];

                    if (!sondaggio) {
                        console.error("❌ SONDAGGIO: dati mancanti");
                        return;
                    }

                    // =========================
                    // ANAGRAFICA
                    // =========================
                    const anagrafica = sondaggio.anagrafica ?? {};

                    const name = anagrafica.nomeProva ?? "";
                    const comm = anagrafica.committente ?? "";
                    const loc = anagrafica.localita ?? "";
                    const add = anagrafica.indirizzo ?? "";
                    const op = anagrafica.op ?? "";
                    const dittes = anagrafica.dittes ?? "";

                    // =========================
                    // TEAM
                    // =========================
                    const team_id = responseData.team_id ?? "";

                    // =========================
                    // PARAMETRI
                    // =========================
                    const param = sondaggio.parametri ?? {};

                    const snd = param.snd ?? "";
                    const tp = param.tp ?? "";
                    const car = param.car ?? "";
                    const riv = param.riv ?? "";
                    const profMax = param.profMax ?? 0;
                    const falda = param.falda ?? "";
                    const qpc = param.qpc ?? 0;
                    const qbf = param.qbf ?? "";
                    const qpz = param.qpz ?? "";
                    const note = param.note ?? "";

                    // =========================
                    // LAYERS
                    // =========================
                    const layers = sondaggio.layers ?? [];

                    // =========================
                    // TESTS
                    // =========================
                    const tests = sondaggio.tests ?? {};

                    // =========================
                    // NAVIGAZIONE
                    // =========================
                    navigate('/ves_borehole', {
                        state: {
                            id,
                            coords2,
                            tipo,

                            name,
                            comm,
                            loc,
                            add,
                            op,
                            dittes,

                            snd,
                            tp,
                            car,
                            riv,
                            profMax,
                            falda,
                            qpc,
                            qbf,
                            qpz,
                            note,

                            layers,
                            tests,
                            team_id
                        }
                    });

                }else if (tipo === 'HVSR') {
                    const veryjson = responseData.data.replace(/'/g, '"');
                    const datjson = JSON.parse(veryjson);
                    const parMV = datjson['value'][0]['ModelV'];
                    const parMH = datjson['value'][0]['ModelH'];
                    const parcHVf = datjson['value'][0]['CurvaHVf']; // curva HV valori x
                    const parcHV = datjson['value'][0]['CurvaHV']; // curva HV valori y
                    const parcSF = datjson['value'][0]['Syntheticf']; // curva sintetica valori x
                    const parcS = datjson['value'][0]['Synthetic']; // curva sintetica valori y
                    const parstdDV = datjson['value'][0]['STDdev']; //deviazione standard della curva
                    const parpsub = datjson['value'][0]['Psub']; //profondità substrato archiviato che deterina la vs eq
                    const parVS = responseData.vsh; //valore Vs eq archiviato
                    //dati intestazione
                    const name = responseData.nome_prova
                    const comm = responseData.committente
                    const loc = responseData.luogo
                    const add = responseData.indirizzo

                    openHVSRReport({id,name,tipo,comm,loc,add,parMV,parMH,parcHVf,parcHV,parcSF,parcS,parstdDV,parpsub,parVS});

                    // Update the DataContext instead of navigating
                }else if (tipo === 'MASW') {
                    const veryjson = responseData.data.replace(/'/g, '"');
                    const datjson = JSON.parse(veryjson);
                    const parMV = datjson['value'][0]['ModelV'];
                    const parMH = datjson['value'][0]['ModelH'];
                    const parFP = datjson['value'][0]['freqPick'];
                    const parVFAS = datjson['value'][0]['Slowness'];
                    const parTRACE = datjson['value'][0]['traccia'];
                    const parpsub = datjson['value'][0]['Psub']; //profondità substrato archiviato che deterina la vs eq
                    const parVS = responseData.vsh; //valore Vs eq archiviato
                    const parinterval = datjson['value'][0]['Spacing'];; //valore Vs eq archiviato
                    //dati intestazione
                    const name = responseData.nome_prova
                    const comm = responseData.committente
                    const loc = responseData.luogo
                    const add = responseData.indirizzo
                    //immagine spettro masw
                    const parspettro = responseData.spettro;

                    openMASWReport({name,tipo,comm,loc,add,parMV,parMH,parFP,parVFAS,parTRACE,parpsub,parVS,parinterval,parspettro});

                }else {
                //in sviluppo
                }

            })
            .catch(errors => {
                console.error(errors);
            });
    };

  const geoIcons = {
    CPT: myIconCPT,
    CPTU: myIconCPTU,
    CPTE: myIconCPTE,
    DMT: myIconDMT,
    SDMT: myIconSDMT,
    SONDAGGIO: myIconSONDAGGIO,
    DELETE: myIconDelete,
  };

  const sisIcons = {
    HVSR: myIconHVSR,
    MASW: myIconMASW,
    DH: myIconDH,
    DELETE: myIconDelete,
  };

  return (
    <div className="general">
    <div id="legendContainer"></div>
      <div className='map1'>
        <a href="/#" id="downloadAnchorElem" style={{ display: "none" }}>a</a>
        <MapContainer center={positionDefault} zoom={10} zoomControl={false} style={{ height: '100%', width: '100%' }}>
          <LayersControl position="topright">
            <LayersControl.BaseLayer checked name="OpenStreetMap.HOT">
              <TileLayer
                url='https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png'
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Esri.WorldImagery">
              <TileLayer
                url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                attribution='&copy; <a href="https://www.esri.com/en-us/arcgis/products/arcgis-online/overview">Esri</a>'
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="OpenStreetMap">
              <TileLayer
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="OpenTopoMap">
              <TileLayer
                url='https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png'
                attribution='&copy; <a href="https://opentopomap.org">OpenTopoMap</a> contributors'
              />
            </LayersControl.BaseLayer>
            
            <LayersControl.Overlay  unchecked name="Vs,eq Distribuitions" >
                        <TileLayer
                            url='https://hat.sofhare.com/wms/vseq/{z}/{x}/{y}.png'
                            attribution='sofHare © 2023 Vs,eq Distribuitions '
                            opacity={0.5}
                            eventHandlers={{
                              add: (e) => {
                                console.log("Added Layer:", e.target);
                                // Create a legend element with colors
                                const legend = document.createElement('div');
                                legend.style.position = 'absolute';
                                legend.style.zIndex = 3000;
                                legend.style.display = 'flex';
                                const items = [
                                {color:'rgba(48, 18, 59, 0.5)',label:'50'},
                                 {color:'rgba(35, 193, 217, 0.5)'},
                                 {color:'rgba(86, 245, 100, 0.5)',label:'180'},
                                  {color:'rgba(202, 243, 79, 0.5)'},
                                  {color:'rgba(227, 203, 50, 0.5)',label:'300'},
                                  {color:'rgba(255, 90, 0, 0.5)'},
                                   {color:'rgba(205, 50, 6, 0.5)',label:'360'},
                                    {color:'rgba(122, 4, 3, 0.5)'}];

                                items.forEach((item,index) => {
                                  const legendItem = document.createElement('div');
                                  legendItem.style.display = 'flex'; // Display label and color box horizontally
                                  legendItem.style.flexDirection = 'column';
                                  legendItem.style.alignItems = 'center'; // Align items vertically in the center
                                  const colorBox = document.createElement('div');
                                  colorBox.style.backgroundColor = item.color;
                                  colorBox.style.width = '30px';
                                  colorBox.style.height = '15px';
                                  //colorBox.style.marginRight = '10px'; // Adjust the margin between color box and label
                                  legendItem.appendChild(colorBox);
                                  const label = document.createElement('div');
                                  label.textContent = item.label;
                                  label.style.alignItems = 'left';
                                  label.style.fontSize = '12px';
                                  label.style.fontWeight = "bold";
                                  legendItem.appendChild(label);
                                  legend.appendChild(legendItem);

                                });
                                // Append the legend to a container element
                                const container = document.getElementById('legendContainer'); // Replace 'legendContainer' with the actual ID of your container element
                                if (container) {
                                  container.appendChild(legend);
                                }
                                e.target.legend = legend;
                              },
                              remove: (e) => {
                                console.log("Removed layer:", e.target);
                                if (e.target && e.target.legend) {
                                const legend = e.target.legend;
                                console.log("Accessed legend:", legend);

                                // Remove the legend element from the container
                                legend.parentNode.removeChild(legend);

                                // Remove the legend property from the target
                                delete e.target.legend;
                              } else {
                                console.log("Legend is not properly stored or accessed.");
                                }
                              }
                           }}
                        />
            </LayersControl.Overlay>
            <LayersControl.Overlay  unchecked name="IPL Distribuitions" >

                        <TileLayer
                            url='https://hat.sofhare.com/wms/lique/{z}/{x}/{y}.png'
                            attribution='sofHare © 2023 IPL Distribuitions '
                            opacity={0.5}
                            eventHandlers={{
                              add: (e) => {
                                console.log("Added Layer:", e.target);
                                // Create a legend element with colors
                                const legend = document.createElement('div');
                                legend.style.position = 'absolute';
                                legend.style.zIndex = 3000;
                                legend.style.display = 'flex';
                                const items = [
                                  { color: 'rgba(10, 20, 80, 0.6)', label: 'Alta' },     // blu scuro
                                  { color: 'rgba(0, 60, 170, 0.6)' },
                                  { color: 'rgba(0, 120, 255, 0.6)' },
                                  { color: 'rgba(0, 200, 255, 0.6)' },
                                  { color: 'rgba(120, 255, 200, 0.6)' },
                                  { color: 'rgba(200, 255, 120, 0.6)' },
                                  { color: 'rgba(255, 220, 80, 0.6)' },
                                  { color: 'rgba(255, 200, 0, 0.6)', label: 'Bassa' }    // giallo
                                ];

                                items.forEach((item,index) => {
                                  const legendItem = document.createElement('div');
                                  legendItem.style.display = 'flex'; // Display label and color box horizontally
                                  legendItem.style.flexDirection = 'column';
                                  legendItem.style.alignItems = 'center'; // Align items vertically in the center
                                  const colorBox = document.createElement('div');
                                  colorBox.style.backgroundColor = item.color;
                                  colorBox.style.width = '30px';
                                  colorBox.style.height = '15px';
                                  //colorBox.style.marginRight = '10px'; // Adjust the margin between color box and label
                                  legendItem.appendChild(colorBox);
                                  const label = document.createElement('div');
                                  label.textContent = item.label;
                                  label.style.alignItems = 'left';
                                  label.style.fontSize = '12px';
                                  label.style.fontWeight = "bold";
                                  legendItem.appendChild(label);
                                  legend.appendChild(legendItem);

                                });
                                // Append the legend to a container element
                                const container = document.getElementById('legendContainer'); // Replace 'legendContainer' with the actual ID of your container element
                                if (container) {
                                  container.appendChild(legend);
                                }
                                e.target.legend = legend;
                              },
                              remove: (e) => {
                                console.log("Removed layer:", e.target);
                                if (e.target && e.target.legend) {
                                const legend = e.target.legend;
                                console.log("Accessed legend:", legend);

                                // Remove the legend element from the container
                                legend.parentNode.removeChild(legend);

                                // Remove the legend property from the target
                                delete e.target.legend;
                              } else {
                                console.log("Legend is not properly stored or accessed.");
                                }
                              }
                           }}
                        />
            </LayersControl.Overlay>



              <LayerGroup>
                <MarkerClusterGroup>
                  <FilteredMarkers points={geopoints} filters={Object.keys(filters).filter(key => filters[key])} icons={geoIcons} viewData={viewData} toelabData={toelabData}
                     handleDelete={handleDelete} navigate={navigate} toggleSelection={toggleSelection} selectedItems={selectedItems}/>
                </MarkerClusterGroup>
              </LayerGroup>

              <LayerGroup>
                <MarkerClusterGroup>
                  <FilteredMarkers points={sispoints} filters={Object.keys(filters).filter(key => filters[key])} icons={sisIcons} viewData={viewData} toelabData={toelabData}
                    handleDelete={handleDelete} toggleSelection={toggleSelection} selectedItems={selectedItems} navigate={navigate} />
                </MarkerClusterGroup>
              </LayerGroup>

          </LayersControl>
          <LeafletRuler />
          <ZoomControl position="bottomright" />
          <LeafletgeoSearch />
        </MapContainer>
        {selectedItems.length > 0 && (
          <div className="report-panel">
            <div className="report-content">
              <b>{selectedItems.length} selezionati</b>

              {Object.keys(groupedByType).map(tipo => (
                <div key={tipo}>
                  {tipo} ({groupedByType[tipo].length})
                </div>
              ))}
            </div>

            <div className="report-actions">
              <button onClick={handleMultiReport}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                </svg>
              </button>

              <button onClick={() => {setSelectedItems([]); setActiveType(null);}}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        )}
      </div>

      {(loading.loadingGeo || loading.loadingSIS) && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      )}
    </div>
  );
};








